import React from 'react';
import { useSelector } from 'react-redux';
import { Paper } from '@mui/material';
import chartSx from './Chart.styles';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

const TextNotes = () => {
    const buccalNotes = useSelector((state) => state.chart.text_buccal) || [],
        occlusalNotes = useSelector((state) => state.chart.text_occlusal) || [],
        theme = useTheme(),
        sx = chartSx(theme);

    return (
        <Paper elevation={2} sx={{ mt: 2, p: 1, ...(sx.bottomBoxes || {}) }}>
            <Box>
                <strong>Buccal:</strong>
                <ul>
                    {buccalNotes.map((note, index) => (
                        <li key={note.name}>
                            <span style={{ color: note.color || '#000000' }}>
                                {index + 1}. {note.content}
                            </span>
                        </li>
                    ))}
                </ul>
            </Box>

            <Box sx={{ mt: 2 }}>
                <strong>Occlusal:</strong>
                <ul>
                    {occlusalNotes.map((note, index) => (
                        <li key={note.name}>
                            <span style={{ color: note.color || '#000000' }}>
                                {index + 1}. {note.content}
                            </span>
                        </li>
                    ))}
                </ul>
            </Box>
        </Paper>
    );
};

export default TextNotes;
